import omit from 'lodash/omit';
import {updatePropertyPreferences} from 'api/propertyPreferences';

export const UPDATE = 'pulp/fewerComparablesReason/UPDATE';

export const initialState = {
  declared: false,
  explanation: '',
  errors: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return {...state, ...action.payload};
    default:
      return state;
  }
}

export function updateFewerComparablesReason(payload, savePreference = false) {
  return (dispatch, getState) => {
    if (savePreference) {
      const {
        propertyDetail: {propertyId},
        fewerComparablesReason,
      } = getState();
      updatePropertyPreferences(propertyId, {
        // `errors` is transient validation state and must never be persisted or rehydrated.
        fewerComparablesReason: omit({...fewerComparablesReason, ...payload}, 'errors'),
      });
    }

    dispatch({
      type: UPDATE,
      payload,
    });
  };
}
